import { AccountPermission } from 'modules/permissions/constants';
import { EMilliSeconds } from 'modules/common/constants/const';
import { isSSG } from 'modules/common/utils/isSSG';
import { useAccount } from 'modules/account/hooks/useAccount';
import { useAccountStatus } from 'modules/accountStatus/hooks/useAccountStatus';
import { useAuth } from 'modules/auth/hooks/useAuth';
import { useCheckAccountPermission } from 'modules/account/hooks/useCheckAccountPermission';

import { useFetchBalanceQuery } from '../actions/fetchBalance';

export const useBalance = () => {
  const { group } = useAccount();
  const { isEnterprise, loaded: accountStatusLoaded } = useAccountStatus();
  const { isLoggedIn } = useAuth();

  const hasAccountStatusAccess = useCheckAccountPermission({
    permission: AccountPermission.AccountStatus,
  });

  const hasBillingRoleAccess = useCheckAccountPermission({
    permission: AccountPermission.Billing,
  });

  const isAccountStatusLoaded = !hasAccountStatusAccess || accountStatusLoaded;

  const shouldFetch =
    !isSSG() &&
    isLoggedIn &&
    hasBillingRoleAccess &&
    !isEnterprise &&
    isAccountStatusLoaded;

  return useFetchBalanceQuery(
    { group },
    { skip: !shouldFetch, pollingInterval: 30 * EMilliSeconds.Second },
  );
};
